import { render, staticRenderFns } from "./StrongsSearch.vue?vue&type=template&id=51626eb1&scoped=true&"
import script from "./StrongsSearch.vue?vue&type=script&lang=js&"
export * from "./StrongsSearch.vue?vue&type=script&lang=js&"
import style0 from "./StrongsSearch.vue?vue&type=style&index=0&id=51626eb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51626eb1",
  null
  
)

export default component.exports